// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeFaculty_home-faculty__dmaoo {
  display: flex;
  padding: 100px 0px 132px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 60px;
  align-self: stretch;
  background: var(--background-color-1);
}
.HomeFaculty_home-faculty--title__MID99 {
  color: var(--accent-color);
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.HomeFaculty_home-faculty--title__MID99 a {
  color: var(--accent-color);
  font-weight: 700;
  text-decoration: underline;
}
.HomeFaculty_home-faculty--swiper__osXbF {
  width: 100%;
}
.HomeFaculty_home-faculty--swiper__osXbF .swiper-wrapper {
  transition-timing-function: linear !important;
  margin: 8px 0;
}
.HomeFaculty_home-faculty--swiper--slide__GV2mO {
  width: 450px !important;
  height: initial !important;
}
.HomeFaculty_home-faculty--swiper__container__TzJ3W {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 60px;
  align-self: stretch;
}
.HomeFaculty_home-faculty--swiper__item__YkO91 {
  border: 1px solid var(--light-grey);
  width: 100%;
  aspect-ratio: 1/1;
}
.HomeFaculty_home-faculty--swiper__item--avatar__iXkob {
  width: 100% !important;
  height: 100%;
  object-fit: cover;
}
.HomeFaculty_home-faculty--swiper__item--avatar--link__wwnsy {
  width: 100% !important;
  height: 100%;
  cursor: pointer;
}
.HomeFaculty_home-faculty--swiper__item--avatar__iXkob span {
  width: 100% !important;
  height: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeFaculty/HomeFaculty.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,qCAAA;AACF;AACE;EACE,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AACI;EACE,0BAAA;EACA,gBAAA;EACA,0BAAA;AACN;AAGE;EACE,WAAA;AADJ;AAEI;EACE,6CAAA;EACA,aAAA;AAAN;AAEI;EACE,uBAAA;EACA,0BAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AADN;AAII;EACE,mCAAA;EACA,WAAA;EACA,iBAAA;AAFN;AAIM;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAIQ;EACE,sBAAA;EACA,YAAA;EACA,eAAA;AAFV;AAKQ;EACE,sBAAA;EACA,uBAAA;AAHV","sourcesContent":[".home-faculty {\n  display: flex;\n  padding: 100px 0px 132px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 60px;\n  align-self: stretch;\n  background: var(--background-color-1);\n\n  &--title {\n    color: var(--accent-color);\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n\n    a {\n      color: var(--accent-color);\n      font-weight: 700;\n      text-decoration: underline;\n    }\n  }\n\n  &--swiper {\n    width: 100%;\n    :global(.swiper-wrapper) {\n      transition-timing-function: linear !important;\n      margin: 8px 0;\n    }\n    &--slide {\n      width: 450px !important;\n      height: initial !important;\n    }\n\n    &__container {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 60px;\n      align-self: stretch;\n    }\n\n    &__item {\n      border: 1px solid var(--light-grey);\n      width: 100%;\n      aspect-ratio: 1/1;\n\n      &--avatar {\n        width: 100% !important;\n        height: 100%;\n        object-fit: cover;\n\n        &--link {\n          width: 100% !important;\n          height: 100%;\n          cursor: pointer;\n        }\n\n        span {\n          width: 100% !important;\n          height: 100% !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-faculty": `HomeFaculty_home-faculty__dmaoo`,
	"home-faculty--title": `HomeFaculty_home-faculty--title__MID99`,
	"home-faculty--swiper": `HomeFaculty_home-faculty--swiper__osXbF`,
	"home-faculty--swiper--slide": `HomeFaculty_home-faculty--swiper--slide__GV2mO`,
	"home-faculty--swiper__container": `HomeFaculty_home-faculty--swiper__container__TzJ3W`,
	"home-faculty--swiper__item": `HomeFaculty_home-faculty--swiper__item__YkO91`,
	"home-faculty--swiper__item--avatar": `HomeFaculty_home-faculty--swiper__item--avatar__iXkob`,
	"home-faculty--swiper__item--avatar--link": `HomeFaculty_home-faculty--swiper__item--avatar--link__wwnsy`
};
export default ___CSS_LOADER_EXPORT___;
